import themeOption from './themeOptions/reducer';
import user from './users/reducer';
import customer from './customer/reducer';
import equipment from './equipment/reducer';
import job from './job/reducer';
import template from './template/reducer';
import messageNotifiation from './Message/reducer';
import ads from './ViperPlusAd/reducer';
import bulletin from './bulletin/reducer';

export default {
  themeOption,
  user,
  customer,
  job,
  equipment,
  template,
  messageNotifiation,
  ads,
  bulletin
};
